import { IIconBase } from '..'

const hasNotificationIcon = ({
  color = '#F5F6FA',
  height = 24,
  width = 24,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.80597 8.51163C5.80597 4.91535 8.57913 2 12 2C15.4209 2 18.194 4.91535 18.194 8.51163V11.329C18.194 12.4999 18.6829 13.6196 19.5463 14.4265C20.4952 15.3131 19.8566 16.8837 18.5472 16.8837H5.45275C4.14343 16.8837 3.50485 15.3131 4.45368 14.4265C5.31715 13.6196 5.80597 12.4999 5.80597 11.329V8.51163Z'
        fill={color}
      />
      <path
        d='M12.0001 22C13.6795 22 15.0409 20.7208 15.0409 19.1429C15.0409 19.1161 15.0405 19.0895 15.0397 19.0629C15.033 18.8324 14.8203 18.6648 14.5749 18.6622L9.43734 18.6075C9.19201 18.6048 8.9753 18.7679 8.96307 18.9981C8.96052 19.0461 8.95923 19.0943 8.95923 19.1429C8.95923 20.7208 10.3207 22 12.0001 22Z'
        fill={color}
      />
      <circle cx='19' cy='4' r='4' fill='#208276' />
    </svg>
  )
}

export default hasNotificationIcon
